import React, {Component} from 'react';
import styles from './PressTransitionSection.scss';
import classNames from 'classnames/bind';
import pressFa from 'assets/images/awair/press-fa.png';
import pressDm from 'assets/images/awair/press-dm.png';
import pressNy from 'assets/images/awair/press-ny.png';
import pressMf from 'assets/images/awair/press-mf.png';
import pressTwt from 'assets/images/awair/press-twt.png';
import pressRc from 'assets/images/awair/press-rc.png';
import pressCnet from 'assets/images/awair/press-cnet.png';
import pressLh from 'assets/images/awair/press-lh.png';
import pressNbc from 'assets/images/awair/press-nbc.png';
import pressTc from 'assets/images/awair/press-tc.png';
import pressVb from 'assets/images/awair/press-vb.png';
import * as SceneEffects from '../../../../lib/functions/SceneEffects';

const cx = classNames.bind(styles);

class PressTransitionSection extends Component {
  pressTransitionSectionRef;
  pressLogos;

  componentDidMount() {
    const {pressTransitionSectionRef, pressLogos} = this;

    SceneEffects.pressFadeInUp(pressTransitionSectionRef, pressLogos.children);
  }

  render() {
    return (
      <section className={cx('press-transition')} ref={ref => this.pressTransitionSectionRef = ref}>
        <div className={cx('press-logos')} ref={ref => this.pressLogos = ref}>
          <div><img src={pressFa} alt='fatherly' /></div>
          <div><img src={pressDm} alt='design milk' /></div>
          <div><img src={pressNy} alt='new york' /></div>
          <div><img src={pressMf} alt='mens fitness' /></div>
          <div><img src={pressTwt} alt='the washington times' /></div>

          <div><img src={pressRc} alt='recode' /></div>
          <div><img src={pressCnet} alt='cnet' /></div>
          <div><img src={pressLh} alt='lifehacker' /></div>
          <div><img src={pressNbc} alt='nbc' /></div>
          <div><img src={pressTc} alt='techcrunch' /></div>
          <div><img src={pressVb} alt='venturebeat' /></div>
        </div>
      </section>
    );
  }
}

export default PressTransitionSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/PressTransitionSection/PressTransitionSection.js